import { render, staticRenderFns } from "./PurchasingReturnList.vue?vue&type=template&id=c31d9484"
import script from "./PurchasingReturnList.vue?vue&type=script&lang=js"
export * from "./PurchasingReturnList.vue?vue&type=script&lang=js"
import style0 from "./PurchasingReturnList.vue?vue&type=style&index=0&id=c31d9484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports